import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

const routes = [
  {
    path: '/',
    meta: { title: '首页' },
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/test_editor',
    meta: { title: '测试' },
    component: () => import('@/views/TestEditor.vue')
  },
  {
    path: '/services',
    meta: { title: '服务' },
    component: () => import('@/views/Services.vue')
  },
  {
    path: '/permission_error',
    meta: { title: '权限错误' },
    component: () => import('@/views/PermissionError')
  },
  {
    path: '/human_detail',
    meta: { title: '数字教师' },
    component: () => import('../views/HumanDetailView.vue')
  },
  {
    path: '/work_detail',
    meta: { title: '慕课' },
    component: () => import('../views/WorkDetailView.vue')
  },
  {
    path: '/buy',
    meta: { title: '充值' },
    component: () => import('../views/BuyView.vue')
  },
  {
    path: '/my',
    component: () => import('../views/MyView.vue'),
    redirect: '/share',
    children: [
      {
        path: '/work',
        meta: { title: '我的课程' },
        component: () => import('../views/my/WorkView.vue')
      },
      {
        path: '/share',
        meta: { title: '慕课中心' },
        component: () => import('../views/my/Share.vue')
      },
      {
        path: '/human',
        meta: { title: '数字教师' },
        component: () => import('../views/my/HumanView.vue')
      },
      {
        path: '/voice',
        meta: { title: '用户管理', roles: ['admin'] },
        component: () => import('../views/admin/VoiceView.vue')
      },
      {
        path: '/human_buy',
        meta: { title: '数字教师-购买' },
        component: () => import('../views/my/BuyHuman.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
  window.pageYOffset = 0
  if (to.meta.title) { document.title = 'AiMooc - ' + to.meta.title }

  const allowAny = [
    '/',
    '/services'
  ]
  if (allowAny.indexOf(to.path) >= 0) {
    next()
  }
  if (!store.state.userInfo || !store.state.userInfo.token) {
    next('/')
  }

  if (to.meta && to.meta.roles && to.meta.roles.indexOf(store.state.userInfo.role) < 0) {
    next('/permission_error')
  }

  next()
})

export default router
